<template>
  <div
    v-if="true"
    class="price-wrapper--custom__supplier"
    :class="{
      'is-drawer': isDrawer,
      'is-compact-msi': isCompactMsi,
      'is-availability': isAvailability,
      'is-sidebar': isSidebar,
      'is-item-not-empty': isItemNotEmpty,
    }"
  >
    <p v-if="isAvailability && getHighestZeroPercentMonth" class="price-msi">{{
      isCompactMsi
        ? $t(`${base}.msi_monthly_price`, {
            msi: getHighestZeroPercentMonth,
            amount: getMonthlyPrice,
            currency: currency,
          })
        : $t(`${base}.msi_up_to_cards`, { value: getHighestZeroPercentMonth })
    }}</p>

    <p v-if="withDiscountSection && _hasDiscount" class="price-discount">
      <el-tag type="success" effect="plain" size="mini">
        {{ _promoDiscount }}
      </el-tag>
      <span class="price-discount__description"
        ><i class="fas fa-check"></i> {{ $t(`${base}.discount_applied`) }}:
        {{ discountWithFormat }} {{ getCurrency }}</span
      >
    </p>

    <p v-if="!isDrawer" class="price-from"
      >{{ $t(`${base}.from`) }}:
      <span>{{ `${symbol}${withoutDiscount} ${getCurrency}` }}</span></p
    >

    <p class="price-to">
      <span class="price-to__value"
        >{{ `${symbol}${amount}` }}
        <span v-if="showPerPerson || hasDateRestriction" class="price-to__label"
          ><span class="price-to__label_currency">{{ getCurrency }}</span
          ><span class="slash-separator"> / </span
          ><span class="person-label">{{
            $t(`${base}.${isPerPerson ? 'per_person' : 'person'}`)
          }}</span></span
        >
        <span v-else class="price-to__label"
          ><span class="price-to__label_currency">{{ getCurrency }}</span> /
          {{ $t(`${base}.total_price_per_person_${promoType}`) }}</span
        >
      </span>
    </p>

    <div class="price-msi-content">
      <p v-if="getCurrency !== currency" class="price-convert"
        >{{ `${symbol}${_amount}` }} <span>{{ currency }}</span></p
      >

      <i
        v-if="isCompactMsi && paymentScheme === 'supplier' && !isDrawer"
        class="fas fa-circle price-separator-landing"
      ></i>

      <p v-if="withTaxesIncludedSection" class="price-taxes-included">{{
        $t(`${base}.taxes_included`)
      }}</p>

      <p v-if="!isAvailability && getHighestZeroPercentMonth" class="price-msi">{{
        isCompactMsi
          ? $t(`${base}.msi_monthly_price`, {
              msi: getHighestZeroPercentMonth,
              amount: getMonthlyPrice,
              currency: currency,
            })
          : isSidebar
          ? $t(
              `${base}.msi_up_to_cards${!isDrawer ? '_sidebar' : ''}${
                !isDrawer && isShortMsi ? '_short_msi' : ''
              }`,
              {
                value: getHighestZeroPercentMonth,
                // eslint-disable-next-line vue/comma-dangle
              }
            )
          : $t(`${base}.msi_up_to_cards`, { value: getHighestZeroPercentMonth })
      }}</p>
    </div>

    <img
      v-if="withPaymentLogos"
      class="payment-logos"
      :src="svgIconName"
      width="100%"
      height="60px"
    />
  </div>
  <div v-else class="price-wrapper--custom" :class="{ 'is-drawer': isDrawer }">
    <!-- eslint-disable -->
    <LadPriceMSI :product="{ is_lad: isLad }" />
    <!-- eslint-enable -->

    <div v-if="_hasDiscount" class="price-with-promotions">
      <div v-if="showPerPerson || hasDateRestriction" class="container-before">
        {{ $t(`${base}.before`) }}
        <span class="price-before">{{ `${symbol}${withoutDiscount}` }}</span>
      </div>

      <div class="container-you-save">
        {{ $t(`${base}.you_save`) }}
        <span class="price-you-save">{{
          `${symbol}${youSaveWithFormat}`
        }}</span>
      </div>
    </div>

    <p
      class="full-price"
      :class="{ 'full-price-with-promotions': _hasDiscount }"
    >
      <span class="symbol">{{ symbol }}</span>
      <span class="price">{{ amount }}</span>
      <span class="container-decimal-currency">
        <span class="decimal">{{ `${decimal}${cents}` }}</span>
        <span class="currency">{{ currency }}</span>
      </span>
    </p>

    <LadExchangeRate
      v-if="paymentScheme === 'supplier'"
      :amount="amountCurrency"
      :currency="currency"
    />

    <p
      v-if="showPerPerson || hasDateRestriction"
      class="total-price-per-person"
      >{{ $t(`${base}.total_price_per_person`) }}</p
    >
    <p v-else class="total-price-per-person">{{
      $t(`${base}.total_price_per_person_${promoType}`)
    }}</p>

    <p class="reserve-with"
      >{{ $t(`${base}.reserve_with`) }}
      <span class="reserve-with--price">{{ reserveWith }}</span>
      <el-tag
        v-if="showInstallments"
        type="success"
        effect="plain"
        size="mini"
        class="reserve-with--installments"
      >
        {{ $t(`${base}.msi`) }}
      </el-tag>
    </p>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import LadPricePromoMixin from '@/components/frontends/Price/components/mixin/promo-supplier'
import LadPriceMSI from '@/components/frontends/Price/components/installments'
import LadExchangeRate from '@/components/frontends/Price/exchange-rate'

export default {
  name: 'LadPriceExperienceCustom',
  components: { LadPriceMSI, LadExchangeRate },
  mixins: [LadPricePromoMixin],
  props: {
    item: { type: Object, require: false, default: () => ({}) },
    isDrawer: { type: Boolean, default: false },
    isSidebar: { type: Boolean, default: false },
    isCompactMsi: { type: Boolean, default: false },
    isAvailability: { type: Boolean, default: false },
    externalPrice: { type: Number, required: false, default: 0 },
    withPaymentLogos: { type: Boolean, default: false },
    withDiscountSection: { type: Boolean, default: false },
    withTaxesIncludedSection: { type: Boolean, default: false },
    isShortMsi: { type: Boolean, default: false },
    isPerPerson: { type: Boolean, default: false },
  },
  data() {
    return {
      base: 'experience.price',
      symbol: '$',
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('experience', {
      exPromotions: 'promotions',
      exIsLad: (state) => state.experience.is_lad,
      exPaymentScheme: (state) => state.experience.payment_scheme,
      exTotalAmount: (state) => state.sales_plan.total_amount,
      exLayawayAmount: (state) => state.sales_plan.layaway_amount,
    }),
    ...mapState('settings', {
      paymentPlans: 'payment_plans',
      currency: 'currency',
      exchangeRate: 'exchange_rate',
    }),
    isItemNotEmpty() {
      return this.item && Object.keys(this.item).length > 0
    },
    promotions() {
      return this.item?.promotions || this.exPromotions
    },
    isLad() {
      return this.item?.is_lad || this.exIsLad
    },
    paymentScheme() {
      return this.item?.payment_scheme || this.exPaymentScheme
    },
    totalAmount() {
      return this.item?.sales_plan?.total_amount || this.exTotalAmount
    },
    layawayAmount() {
      return this.item?.sales_plan?.layaway_amount || this.exLayawayAmount
    },
    svgIconName() {
      return require(`@/assets/sprite/svg/payments/localadventures-payments-${this.currency.toLowerCase()}.svg`)
    },
    currentRate() {
      const exchange = this.exchangeRate.find((t) => t.code === this.currency)
      const value = exchange ? exchange.rate : 0

      return this.$options.filters.ladFnPrecision(value)
    },
    /** meses sin intereses */
    showInstallments() {
      const k = this.isLad ? 'lad' : 'others'

      return (this.paymentPlans[k] || []).some((t) => t.percent === 0)
    },
    getHighestZeroPercentMonth() {
      const k = this.isLad ? 'lad' : 'others'
      const valid = (this.paymentPlans[k] || []).filter((t) => t.percent === 0)

      if (!valid.length) return null

      return valid.reduce((max, curr) => (curr.month > max.month ? curr : max))
        .month
    },
    getMonthlyPrice() {
      const _price = this.getHighestZeroPercentMonth
        ? this._amountCurrency / this.getHighestZeroPercentMonth
        : this._amountCurrency
      return this.$options.filters.ladFnCurrency(
        _price,
        this.currency,
        true,
        '',
        0
      )
    },
    // TODO: this is necessary to section price
    reserveWith() {
      return this.$options.filters.ladFnCurrency(
        this.layawayAmount,
        this.currency
      )
    },
    showPerPerson() {
      return !(
        this.promoType.startsWith('promo_2x1') ||
        this.promoType.startsWith('promo_3x1')
      )
    },
    hasDateRestriction() {
      return this.promoType.endsWith('_dates') && !this.showDiscountOrPromo
    },
    _hasDiscount() {
      return (
        this.hasDiscount || (!this.showPerPerson && !this.hasDateRestriction)
      )
    },
    _promoDiscount() {
      let promoDiscount = ''
      if (this._hasDiscount) {
        switch (true) {
          case this.promoType.startsWith('promo_2x1'):
            promoDiscount = '2x1'
            break

          case this.promoType.startsWith('promo_3x1'):
            promoDiscount = '3x1'
            break

          default:
            promoDiscount = this.promoDiscount
            break
        }
      }

      return promoDiscount
    },
    youSaveWithFormat() {
      let value = 0
      if (this._hasDiscount) {
        switch (true) {
          case this.promoType.startsWith('promo_2x1'):
            value = this.$options.filters.ladFnCurrency(
              this.price,
              this.currency,
              true,
              ''
            )
            break

          case this.promoType.startsWith('promo_3x1'):
            value = this.$options.filters.ladFnCurrency(
              this.price * 2,
              this.currency,
              true,
              ''
            )
            break

          default:
            value = this.discountWithFormat
            break
        }
      }

      return value
    },
    hasPrice() {
      return parseFloat(this.externalPrice || this.totalAmount) > 0
    },
    price() {
      let _price = this.externalPrice || this.totalAmount
      if (this.paymentScheme === 'supplier') {
        _price = this.$options.filters.ladFnPrecision(_price)

        if (this.currentRate.value > 0) {
          _price =
            this.currentRate.value < 1
              ? _price.multiply(this.currentRate)
              : _price.divide(this.currentRate)
        }
      }
      return _price
    },
    getCurrency() {
      return this.paymentScheme === 'supplier' ? 'USD' : this.currency
    },
    amountCurrency() {
      return this.$options.filters
        .ladFnCurrency(this.price, this.getCurrency, false)
        .subtract(this.discountAmount)
    },
    amountWithoutFormat() {
      return this.amountCurrency.format(false).replace(this.symbol, '')
    },
    amount() {
      return this.showZeroPrice && this.amountCurrency.dollars() === 0
        ? '-'
        : this.amountWithoutFormat.slice(0, -3)
    },
    cents() {
      const length = this.amountWithoutFormat.length

      return this.amount === '-' && this.amountCurrency.cents() === 0
        ? '--'
        : this.amountWithoutFormat.slice(-2, length)
    },
    decimal() {
      return this.amountCurrency.s.decimal
    },
    // TODO: this is necessary to section price original
    _price() {
      return this.externalPrice || this.totalAmount
    },
    _amountCurrency() {
      return this.$options.filters
        .ladFnCurrency(this._price, this.currency, false)
        .subtract(this._discountAmount)
    },
    _amountWithoutFormat() {
      return this._amountCurrency.format(false).replace(this.symbol, '')
    },
    _amount() {
      return this.showZeroPrice && this._amountCurrency.dollars() === 0
        ? '-'
        : this._amountWithoutFormat.slice(0, -3)
    },
    _cents() {
      const length = this._amountWithoutFormat.length

      return this._amount === '-' && this._amountCurrency.cents() === 0
        ? '--'
        : this._amountWithoutFormat.slice(-2, length)
    },
    _decimal() {
      return this._amountCurrency.s.decimal
    },
  },
}
</script>

<style lang="scss">
.price-wrapper--custom {
  .wrapper-installments-promotion {
    .discount-value {
      border-radius: 10px;
      border: 1px solid rgba(201, 24, 0, 0.3);
      padding: 3px 5.3px 3px 6px;

      span {
        color: #c91800;
        font-size: 11.2px;
        font-style: normal;
        font-weight: 700;
        line-height: 12.88px; /* 115% */
      }
    }
  }

  .price-with-promotions {
    margin: 10px 0;

    .container-before,
    .container-you-save {
      display: inline-block;
      color: #000;
      font-size: 11.2px;
      font-style: normal;
      font-weight: 400;
      line-height: 12.88px; /* 115% */
      text-transform: capitalize;

      .price-before {
        font-size: 14px;
        font-weight: 700;
        text-decoration: line-through;
      }

      .price-you-save {
        font-size: 14px;
        font-weight: 500;
      }
    }

    .container-you-save {
      color: #ef4343;
      border-radius: 50px;
      border: 0;
      padding: 4px 12px;
    }
  }

  .price-with-promo-type {
    // margin-top: 10px;

    .container-promo-type {
      display: inline-block;
      color: black;
      font-size: 11.2px;
      font-style: normal;
      font-weight: 400;
      line-height: 12.88px; /* 115% */
      text-transform: capitalize;
      border-radius: 50px;
      border: 1px solid rgba(201, 24, 0, 0.3);
      padding: 4px 12px;

      .price-promo-type {
        color: #c91800;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .full-price {
    margin: 15px 0 0;

    .symbol {
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 16.1px; /* 115% */
      vertical-align: top;
    }

    .price {
      color: #000;
      font-size: 49px;
      font-style: normal;
      font-weight: 700;
      line-height: 35.35px; /* 115% */
    }

    .decimal {
      color: #000;
      font-size: 12.6px;
      font-style: normal;
      font-weight: 400;
      line-height: 14.49px; /* 115% */
      vertical-align: top;
    }

    .currency {
      color: #030303;
      font-size: 10.1px;
      font-style: normal;
      font-weight: 700;
      line-height: 11.59px; /* 114.752% */
      text-transform: uppercase;
    }

    .container-decimal-currency {
      display: inline-flex;
      flex-direction: column;
      vertical-align: top;
      height: 38px;
      place-content: space-between;
    }

    &-with-promotions {
      .price,
      .decimal {
        color: #1aa31c;
      }
    }
  }

  .total-price-per-person {
    margin: 0;
    color: #000;
    font-size: 15.2px;
    font-style: normal;
    font-weight: 700;
    line-height: 12.88px; /* 84.737% */
  }

  .reserve-with {
    display: none;
    color: #000;
    font-size: 15.2px;
    font-style: normal;
    font-weight: 400;
    line-height: 12.88px; /* 84.737% */

    &--price {
      font-weight: 700;
    }

    &--installments {
      border-radius: 50px;
      border: 1.5px solid #1aa31c;
      color: #1aa31c;
      font-size: 11.2px;
      font-weight: 700;
    }
  }

  &.is-drawer {
    .wrapper-installments-promotion,
    .price-with-promotions,
    .total-price-per-person {
      display: none;
    }

    .full-price {
      margin: 0;

      .symbol,
      .price {
        color: #1aa31c;
        font-size: 20px;
        line-height: 12.88px; /* 64.4% */
        font-weight: 700;
        vertical-align: text-top;
      }

      .container-decimal-currency {
        display: unset;
        vertical-align: unset;
        height: unset;
        margin-left: -4px;

        .decimal {
          vertical-align: unset;
          color: #1aa31c;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
        }
      }
    }

    .reserve-with {
      display: block;
      margin: 0;
    }
  }
}

.price-wrapper--custom__supplier {
  padding: 10px 0;
  display: grid;
  gap: 8px;

  .price {
    &-msi-content {
      display: grid;
      gap: 8px;
    }

    &-discount {
      margin: 0;

      .el-tag {
        background-color: transparent;
        border: 1px solid #429fff;
        border-radius: 10px;
        font-weight: 700;
        font-size: 11px;
        color: #429fff;
      }

      &__description {
        font-weight: 700;
        font-size: 14px;
        color: #429fff;
      }
    }

    &-from {
      font-weight: 700;
      font-size: 14px;
      color: #5c5c5b;
      line-height: 1.2;
      margin: 0;

      span {
        text-decoration: line-through;
      }
    }

    &-to {
      font-weight: 700;
      color: #1da41f;
      margin: 0;

      &__value {
        font-size: 38px;
        line-height: normal;

        @media (min-width: 768px) {
          font-size: 48px;
        }
      }

      &__label {
        font-size: 16px;
      }
    }

    &-convert {
      font-weight: 700;
      font-size: 32px;
      color: #429fff;
      line-height: normal;
      margin: 0;

      span {
        font-size: 16px;
      }
    }

    &-taxes-included {
      font-weight: 400;
      font-size: 14px;
      color: #1d1d1d;
      line-height: normal;
      margin: 0;
    }

    &-msi {
      font-weight: 700;
      font-size: 18px;
      color: #221f20;
      line-height: normal;
      margin: 0;
    }
  }

  .payment-logos {
    max-width: fit-content;
  }

  &.is-compact-msi {
    &:not(.is-drawer) {
      .price {
        &-msi-content {
          display: block;

          @media (min-width: 768px) {
            display: grid;
          }
        }

        &-convert {
          display: inline-block;
          font-size: 18px;
          color: #221f20;

          span {
            font-size: 16px;
          }

          @media (min-width: 768px) {
            display: block;
            font-size: 32px;
            color: #429fff;

            span {
              font-size: 16px;
            }
          }
        }

        &-separator-landing {
          color: #221f20;
          font-size: 6px;
          vertical-align: middle;

          @media (min-width: 768px) {
            display: none;
          }
        }

        &-msi {
          display: inline-block;

          @media (min-width: 768px) {
            display: block;
          }
        }
      }
    }
  }

  &.is-availability {
    gap: 4px;
    padding: 0 0 5px;
    text-align: right;

    .price {
      &-discount {
        &__description {
          font-size: 11px;
        }
      }

      &-from {
        font-size: 14px;
        font-weight: 400;
      }

      &-to {
        &__value {
          font-size: 32px;
        }

        &__label {
          font-size: 24px;
        }
      }

      &-convert {
        font-size: 20px;
      }

      &-msi {
        font-size: 16px;
      }
    }
  }

  &.is-sidebar {
    gap: 4px;

    .price-discount,
    .payment-logos {
      display: none;
    }

    .price-from {
      font-weight: 400;
      font-size: 14px;
      color: #5c5c5b;
    }

    .price-to {
      &__value {
        font-weight: 700;
        font-size: 31px;
        color: #221f20;
      }

      &__label {
        font-weight: 400;
        font-size: 20px;
        color: #221f20;
      }

      &__label_currency {
        font-weight: 700;
        font-size: 31px;
        color: #221f20;
      }
    }

    .price-msi-content {
      gap: 4px;

      .price-convert {
        font-weight: 400;
        font-size: 24px;
        color: #221f20;

        span {
          font-size: 24px;
        }
      }

      .price-msi {
        font-weight: 400;
        font-size: 12.8px;
        color: #5c5c5b;
      }
    }
  }

  &.is-drawer {
    padding: 0;
    gap: 0;

    .price {
      &-from {
        font-size: 14px;
      }

      &-to {
        &__label {
          font-size: 14px;
        }
      }

      &-convert {
        font-size: 18px !important;

        span {
          font-size: 18px !important;
        }
      }

      &-msi {
        font-size: 14px;
      }
    }

    .payment-logos {
      display: none;
    }
  }

  &.is-item-not-empty {
    .price {
      &-from {
        font-size: 14px;
      }

      &-to {
        &__value {
          font-size: 26px;
        }

        &__label {
          font-size: 14px;
        }

        &__label_currency {
          font-size: 24px;
        }
      }

      &-convert {
        font-size: 18px;

        span {
          font-size: 12px;
        }
      }

      &-msi {
        font-size: 14px;
      }
    }
  }
}
</style>
